module.exports = __webpack_public_path__ + "img/martinique.4f9f1bcc.svg";